exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".searchSelect__EditableSearchSelect-module___W6u4b {\n  width: 100%;\n}\n", ""]);

// Exports
exports.locals = {
	"searchSelect": "searchSelect__EditableSearchSelect-module___W6u4b"
};